<script setup>
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useSession } from '@/stores/session'
import FiltreSociete from '@/components/FiltreSociete.vue'

const session = useSession()
const router = useRouter()
const erreur = ref('')

// Le profil est chargé une fois pour toutes : il porte le nom affiché et la
// liste des sociétés, dont dépend le filtre.
onMounted(async () => {
  if (session.chargee) return
  try {
    await session.charger()
  } catch (e) {
    // 401 déjà tenté et rejoué par le client HTTP : la session est finie.
    if (e.response && e.response.status === 401) {
      session.deconnecter()
      router.push({ name: 'demande-lien' })
      return
    }
    erreur.value = 'Vos informations n’ont pas pu être chargées.'
  }
})

function deconnecter() {
  session.deconnecter()
  router.push({ name: 'demande-lien' })
}
</script>

<template>
  <!-- APERÇU ADMINISTRATEUR — en tête de page, permanent, et non dans un
       coin. Un bandeau discret finit par ne plus être lu, et ce qui est
       affiché ici sont les données d'un vrai client. Le drapeau vient de
       l'API (/client/moi), donc un rechargement ne le fait pas oublier. -->
  <div v-if="session.apercu" class="bandeau-apercu">
    <strong>Aperçu administrateur</strong> — vous regardez l’espace de
    {{ session.nomAffiche || 'ce client' }}. Lecture seule, et cet aperçu
    expire au bout de quelques minutes.
  </div>
  <header class="barre">
    <div class="barre-haut">
      <span class="barre-marque">REUNIBOX</span>
      <span class="barre-espace" />
      <FiltreSociete v-if="session.filtrable" />
      <span v-if="session.nomAffiche" class="discret">{{ session.nomAffiche }}</span>
      <button class="bouton discret" type="button" @click="deconnecter">
        {{ session.apercu ? 'Fermer l’aperçu' : 'Se déconnecter' }}
      </button>
    </div>
    <nav class="barre-nav">
      <RouterLink to="/tableau-de-bord" active-class="actif">Accueil</RouterLink>
      <RouterLink to="/contrats" active-class="actif">Contrats</RouterLink>
      <RouterLink to="/factures" active-class="actif">Factures</RouterLink>
      <RouterLink to="/documents" active-class="actif">Documents</RouterLink>
      <RouterLink to="/demandes" active-class="actif">Demandes</RouterLink>
      <RouterLink to="/profil" active-class="actif">Mon profil</RouterLink>
    </nav>
  </header>

  <main class="contenu">
    <p v-if="erreur" class="message erreur">{{ erreur }}</p>
    <slot />
  </main>
</template>
